import Box from '../box';

export default function rectToBox(rect) {
    var origin = rect.origin;
    var bottomRight = rect.bottomRight();

    return new Box(origin.x, origin.y, bottomRight.x, bottomRight.y);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/core/utils/rect-to-box.js
// module id = 622
// module chunks = 29